import store from "../../redux/store";
import {ACCOUNT_SWITCH_USER_VIEW, enterprisePlan, isPaidLikePlan, PAID_LIKE_PLANS} from "../constants";

/**
 * Created by Workaxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Date: 11/07/23
 * Time: 1:04 pm
 * Project: W-CRM-Frontend
 */
export const isPrivilegeAllowed = (allowed = []) => {
    const state = store.getState();
    return allowed.includes(
        state.profile.profile?.data?.userorgrolemapping?.role?.name
    );
};

export const isPlanAllowed = (allowed = []) => {
    const state = store.getState();
    const plan = state.profile.profile.data?.usersubscriptionmapping?.subscription?.name;
    if (allowed.includes(plan)) return true;
    // Treat paid-like tiers as interchangeable when the gate lists any paid-like plan.
    const gateIncludesPaidLike = allowed.some((name) => PAID_LIKE_PLANS.includes(name));
    if (gateIncludesPaidLike && isPaidLikePlan(plan)) return true;
    return allowed.includes(enterprisePlan) && process.env.REACT_APP_ENTERPRISE === "true";
};

export const isCULActionAllowed = () => {
    const state = store.getState();
    return state.profile?.viewingAs?.data?.id !== ACCOUNT_SWITCH_USER_VIEW;
};